import { executeReport, REPORT_TYPES } from '../../../../../../../../../../logic/utils/reportRequest';

export default async function SqlAvgProcTime(startTime, endTime) {
  // Получаем данные через новый API
  const result = await executeReport(REPORT_TYPES.GENERAL_AVG_PROC_TIME, { startTime, endTime });

  // Возвращаем в том же формате - dataObjects уже имеют числовые индексы
  return { dataObjects: result.dataObjects, query: result.query };
}
